// A connector's label QR opens /claim#<serial>.<claim code>. The pair is kept
// in sessionStorage across the login redirect and consumed by the claim dialog.

const KEY = "bf.pendingClaim";

export function rememberClaim(raw: string): void {
  if (raw) sessionStorage.setItem(KEY, raw);
}

export function hasPendingClaim(): boolean {
  return sessionStorage.getItem(KEY) !== null;
}

/** The pending pair without consuming it (the sign-up form pre-fills from it). */
export function peekPendingClaim(): { serial: string; claim_code: string } | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  const [serial, code = ""] = raw.split(".");
  return { serial: serial.trim().toUpperCase(), claim_code: code.trim().toUpperCase() };
}

export function forgetPendingClaim(): void {
  sessionStorage.removeItem(KEY);
}

export function takePendingClaim(): { serial: string; claim_code: string } | null {
  const raw = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  if (!raw) return null;
  const [serial, code = ""] = raw.split(".");
  return { serial: serial.trim().toUpperCase(), claim_code: code.trim().toUpperCase() };
}
